export const GetCurrentUser = () => {
  try {
    const storedUser = localStorage.getItem('user');
    
    if (!storedUser) return null;
    
    // First parse
    let parsed = JSON.parse(storedUser);
    
    // If it's still a string (double-stringified), parse again
    if (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }
    
    return parsed;
  } catch (error) {
    console.error('Error parsing user:', error);
    return null;
  }
};